<template>
  <div>
    <AlarmsComponent></AlarmsComponent>
  </div>
</template>

<script>
import AlarmsComponent from "@/components/utils/AlarmsComponent.vue";

export default {
  name: "AlarmsPage",

  components: {
    AlarmsComponent,
  },
};
</script>
